<template>
	<div class="container">
		<section class="catalog">
			<div class="row">
				<div class="col-sm-3">
					<filter></filter>
					<!-- <subcategories></subcategories> -->
					<!-- <color></color> -->
				</div>
				<div class="col-sm-9">
					<div class="row catalog-cards" style="margin-bottom: 20px">
						<div class="col-xs-12 col-sm-6 col-md-4" v-for="result in render_results | filter min max null null | paginate $route.query.page per_page">
							<cards :product="result"></cards>
						</div>
					</div>
					<div v-if="!render_results.length" class="category-title">
						<div v-if="searching" class="loading-products text-general empty">Buscando productos<loader class="loader"></loader></div>
						<div v-else>
							<h2 class="no-top text-uppercase">Lo sentimos</h2>
							<p class="text-general">No encontramos algo relacionado con tu búsqueda</p>
							<ul class="text-gray-sm">
								<li>Prueba cambiando algunas palabras</li>
								<li>Revisa las categorías para encontrar productos similares</li>
							</ul>
						</div>
					</div>
					<pagination :url="url" :items="render_results | filter min max null null" :per_page="per_page"></pagination>
				</div>
			</div>
		</section>
	</div>
</template>

<style scoped>
	.no-top{
		margin-top: 0;
		padding-top: 0;
	}
	.col-sm-4{
		margin-bottom: 30px;
	}
	.col-sm-9{
		padding-left: 20px;
	}
	ul{
		padding: 60px 30px;
	}
</style>

<script>

import Cards from '../components/Home/Card.vue';
import Filter from '../components/Product/Filter.vue';
import Subcategories from '../components/Product/Subcategories.vue';
import Color from '../components/Product/Color.vue';
import Store from '../store/store';
import { search } from '../store/actions';
import { router } from '../routes/routes';
import Loader from '../components/Loader.vue';
import Pagination from '../components/Pagination.vue';

export default {
	// ---- DATA ----

	data () {
		return {
			url: '/resultados?page=',
			per_page: 30,
			products: Store.state.products
		};
	},

	// ---- VUEX ----

	vuex: {
		getters: {
			min: state => state.min_price,
			max: state => state.max_price,
			searching: state => state.searching_product,
			results: state => {
				// let products = state.products;
				// let results = state.results;

				// for (let i = 0, p = products; i < p.length; i++) {
				// 	if (!p[i].images.length)
				// 		for (let j = 0, r = results; j < r.length; j++) {
				// 			if (p[i].id == r[j].id) {
				// 				r[j].images = p[i].images;
				// 			}
				// 		}
				// }

				return state.results.map(p => p);
			}
		},
		actions: {
			search
		}
	},

	// ---- RENDER ----

	computed:  {
		render_results () {
			return this.results;
		}
	},

	// ---- COMPONENTS ----

	components: {
		Cards,
		Filter,
		Subcategories,
		Color,
		Loader,
		Pagination
	},

	// ---- READY ----

	ready () {
		if (this.$route.query.search) {
			this.search(this.$route.query.search);
		}

		router.afterEach(transition => {
			if (this.$route.query.search) {
				this.search(this.$route.query.search);
			}
		});

		// $("div.col-sm-2").removeClass("col-sm-2").addClass("col-sm-3");

		// if (this.$route.query.search)
		// 	this.url = `/resultados?search=${ this.$route.query.search }&page=`
	}
}
</script>



// WEBPACK FOOTER //
// Search-result.vue?78166114